Shopify.theme.jsTestimonials = {
  init: function ($section) {
    const $testimonialSlider = $section.find('[data-slider]');
    
    // Default settings
    const flickityOptions = {
      wrapAround: false,
      initialIndex: 1,
      prevNextButtons: false,
      pageDots: true,
      watchCSS: true,
      cellAlign: 'center',
      contain: true
    };
    
    // Check window width and adjust options
    function setupSlider() {
      if (window.innerWidth <= 798) {
        // Mobile settings - no grouping
        $testimonialSlider.flickity($.extend({}, flickityOptions, {
          groupCells: false
        }));
      } else {
        // Desktop settings - group 3 cells
        $testimonialSlider.flickity($.extend({}, flickityOptions, {
          groupCells: 3
        }));
      }
    }
    
    // Initialize on load
    setupSlider();
    
    // Re-initialize on resize
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        $testimonialSlider.flickity('destroy');
        setupSlider();
      }, 250);
    });

    // Resize flickity when the slider is settled
    $testimonialSlider.on('settle.flickity', function () {
      $testimonialSlider.flickity('resize');
    });

    $section.on('click', '.testimonial__nav--prev', function () {
      $testimonialSlider.flickity('previous');
    });

    $section.on('click', '.testimonial__nav--next', function () {
      $testimonialSlider.flickity('next');
    });
  },
  // ... rest of your code remains the same ...
}